import { BLAdmin } from '@/types/user';
import { jwtDecode } from '@/utils/jwt/jwt-decode';
import { setStorageItem } from '@/utils/storage/local-storage';
import { StoredTokens } from '@/utils/storage/types';

export const getUserFromToken = (token: string): BLAdmin => jwtDecode(token) as BLAdmin;

export const setStorageAndGetUser = (token: string): BLAdmin => {
  //set token in localStorage
  setStorageItem(StoredTokens.currentUser, token, 1);

  //decode JWT
  const user = getUserFromToken(token);

  //use plain localStorage for this key so it doesn't have to be parsed by the useChannelMonitor hook
  localStorage.setItem(StoredTokens.currentChannel, String(user.active_channel));

  return user;
};
